import React, { useState, useEffect } from 'react'
import Container from 'js/pages/LandingPages/components/Container'
import { FeatureImageType } from 'js/components/FeatureImage'
import { SharedSectionProps } from './types'
import { useKeenSlider } from 'keen-slider/react'
import Card from './Card'
import { isSSR } from 'js/isSSR'

type Props = {
  title: string
  features: {
    heading: string | null
    text: string | null
    image: { responsiveImage: FeatureImageType } | null
  }[]
  downloadLinkText: string | React.ReactNode
  onOpenModal: (flag: boolean) => void
} & SharedSectionProps

const HighlightedFeatures = ({ title, features }: Props) => {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  const [sliderRef] = useKeenSlider(
    {
      loop: true,
      slides: {
        perView: 1.2,
        spacing: 15,
        origin: 'center',
      },
      breakpoints: {
        '(min-width: 600px)': {
          disabled: true,
        },
      },
    },
    [],
  )

  return (
    <section className="py-20">
      <Container>
        <h2 className="mb-32 text-center leading-37 type-32-bold md:mx-auto md:max-w-384 lg:mb-48 lg:max-w-512 lg:leading-52 lg:type-48-bold">
          {title}
        </h2>
        <div
          ref={!isSSR && isMounted ? sliderRef : null}
          className="keen-slider md:mx-16 md:flex md:gap-x-[10px] md:gap-x-[20px] md:gap-y-[16px] md:pb-32"
        >
          {features.map((item) => (
            <div key={item.heading} className="keen-slider__slide pb-24">
              <Card
                image={item.image?.responsiveImage as FeatureImageType}
                title={item.heading as string}
                description={item.text as string}
              />
            </div>
          ))}
        </div>
      </Container>
    </section>
  )
}

export default HighlightedFeatures
